import Button from '@ui/components/Button/Button';
import Card from '@ui/components/Card/Card';
import CardBody from '@ui/components/Card/components/CardBody/CardBody';
import CardImage from '@ui/components/Card/components/CardImage/CardImage';
import Content from '@ui/components/Content/Content';
import { getHeadingTag } from '@ui/utils';
import Heading from '@ui/components/Heading/Heading';
import styles from './Intro.module.scss';
import React from 'react';
import PropTypes from 'prop-types';

const Intro = ({
  headingLevel = 2,
  introImage,
  introTitle,
  introContent,
  introButtonText,
  setStep,
}) => (
  <Card className={styles.card}>
    {!!introImage && (
      <CardImage
        aspectRatio={0.49}
        image={{
          ...introImage,
          ...{
            src: introImage.url,
            alt: introImage.alt || introImage.title,
          },
        }}
      />
    )}
    <CardBody>
      {!!introTitle && (
        <Heading as={getHeadingTag(headingLevel)} size="h4">
          {introTitle}
        </Heading>
      )}
      {!!introContent && <Content withParser>{introContent}</Content>}
      {!!introButtonText && (
        <Button
          className={styles.introButton}
          isElevated
          onClick={() => setStep(prev => prev + 1)}
        >
          {introButtonText}
        </Button>
      )}
    </CardBody>
  </Card>
);

Intro.propTypes = {
  headingLevel: PropTypes.number,
  introButtonText: PropTypes.string,
  introContent: PropTypes.string,
  introImage: PropTypes.shape({
    alt: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  introTitle: PropTypes.string,
  setStep: PropTypes.func,
};

export default Intro;
